var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.82029 0 0 5.82029 0 13C0 20.1797 5.82029 25.9999 13 25.9999C20.1797 25.9999 25.9999 20.1797 25.9999 13C25.9923 5.8235 20.1765 0.00767159 13 0ZM13 24.1428C6.84594 24.1428 1.85712 19.154 1.85712 13C1.85712 6.84594 6.84594 1.85712 13 1.85712C19.154 1.85712 24.1428 6.84594 24.1428 13C24.1362 19.1513 19.1513 24.1362 13 24.1428Z",
    fill: "#778797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35713 13C9.38279 13 10.2143 12.1685 10.2143 11.1429C10.2143 10.1172 9.38279 9.28574 8.35713 9.28574C7.33147 9.28574 6.5 10.1172 6.5 11.1429C6.5 12.1685 7.33147 13 8.35713 13Z",
    fill: "#778797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6423 13C18.6679 13 19.4994 12.1685 19.4994 11.1429C19.4994 10.1172 18.6679 9.28574 17.6423 9.28574C16.6166 9.28574 15.7852 10.1172 15.7852 11.1429C15.7852 12.1685 16.6166 13 17.6423 13Z",
    fill: "#778797"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5558 16.1381C16.2491 15.7271 15.6673 15.6425 15.2563 15.9493C15.2385 15.9626 15.2213 15.9764 15.2044 15.991C13.8913 16.9501 12.1087 16.9501 10.7956 15.991C10.4076 15.6556 9.82115 15.6983 9.48583 16.0863C9.15046 16.4743 9.19317 17.0607 9.58115 17.396C9.59791 17.4105 9.61521 17.4244 9.63301 17.4377C11.6206 18.9569 14.3794 18.9569 16.367 17.4377C16.7781 17.1309 16.8626 16.5491 16.5558 16.1381Z",
    fill: "#778797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.a98559f23055161c99b5e1ec9329be14.svg";
export { ForwardRef as ReactComponent };